import { FC } from 'react';
import styled from 'styled-components';

import { remify } from '#/service/utils';

import { HeadingProps } from '../FormInput.types';

const Text = styled.div`
  font: var(--fontStyleTitle3);
  margin-top: ${remify(48)};
  margin-bottom: ${remify(16)};
  text-align: left;
`;

export const Heading: FC<HeadingProps> = ({ heading }) => {
  if (!heading?.text) {
    return null;
  }

  return <Text>{heading.text}</Text>;
};
